// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"cd624914","415":"5c6092e0","709":"0c6d764a","871":"cd624914","873":"cd624914"}[chunkId] + ".chunk.css";
};